

















import { Component, Vue } from 'vue-property-decorator'

import grocery from '@/store/modules/grocery'

import HeaderAddInput from '@/components/HeaderAddInput'
import HeaderBar from '@/components/HeaderBar'
import HeaderFilterInput from '@/components/HeaderFilterInput'

import { Category, List } from '@/datastore/models'

import PantryList from './components/PantryList.vue'

@Component({
	components: {
		HeaderAddInput,
		HeaderBar,
		HeaderFilterInput,
		PantryList,
	},
})
export default class PantryPage extends Vue {

	filter = ''

	newCategoryName = ''

	get categories(): Category[] {

		switch (this.listId) {
			case 'all':
				return grocery.categories
			default:
				if (this.list) {
					return Object.values(grocery.listCategories[this.listId] || [])
						.map(i => grocery.categoriesCollection[i])
						.filter(c => !!c)
						.sort((a, b) => a.name.localeCompare(b.name))
				}

				return []
		}
	}

	get list(): List {

		return grocery.listsCollection[this.listId]
	}

	get listId(): string {

		return this.$route.params.id
	}

	get title(): string {

		return this.list ? this.list.name : 'All Items'
	}

	async createCategory(): Promise<void> {

		const { list, listId, newCategoryName } = this

		if (newCategoryName) {
			const categoryRef = await grocery.addCategory(newCategoryName)

			if (list) {
				await grocery.updateList({
					categoryIds: [categoryRef.id, ...(grocery.listCategories[listId] || [])],
					listId,
				})
			}
		}
	}

}

